/**
 * BILA MAIN SCRIPTS
 */

jQuery(document).ready(function ($) {
  ("use strict");

  /**
   * -------------------
   * ACCESSABILITY FIX
   * -------------------
   */

  $(".edublink-woo-mini-cart-link").attr("aria-label", "View Shopping Cart");
  $(".edublink-mobile-hamburger-menu a").attr(
    "aria-label",
    "Toggle Main Navigation",
  );
  $(".edublink-mobile-menu-close a").attr(
    "aria-label",
    "Close Main Navigation",
  );
  $(".close-trigger").attr("aria-label", "Close Search Box");
  $(".search-trigger").attr("aria-label", "Toggle Search Box");
  $(".search-form button").attr("aria-label", "Submit Search Form");
  $(".edublink-filter-close-trigger a").attr(
    "aria-label",
    "Close Filter Sidebar",
  );

  $(".page-numbers.next").attr("aria-label", "Navigate to next page");
  $(".page-numbers.prev").attr("aria-label", "Navigate to previous page");
  $("[tutor-toggle-course-filter]").attr("aria-label", "Open Filter Sidebar");
  $("[tutor-hide-course-filter]").attr("aria-label", "Close Filter Sidebar");

  /**
   * -------------------
   * Courses Archive Filter Sidebar
   * -------------------
   */

  // Initialize all widget content as expanded by default
  $(".tutor-course-filter .tutor-widget-content").slideDown(0);

  // Add click event to all widget titles
  $(".tutor-course-filter .tutor-widget-title").on("click", function (e) {
    e.preventDefault();

    // Find the widget content related to this title
    var $widgetContent = $(this)
      .closest(".tutor-widget")
      .find(".tutor-widget-content");

    // Toggle the content with smooth animation
    $widgetContent.slideToggle(300);
    $(this).closest(".tutor-widget").toggleClass("collapsed");
  });

  /**
   * -------------------
   * Create WooCommerce-style rating
   * -------------------
   */

  function createWooCommerceRating() {
    $(
      '.edublink-contact-form-rate .wpcf7-form-control-wrap[data-name="rating"]',
    ).each(function () {
      var $container = $(this);
      var $select = $container.find("select");

      // Skip if stars already exist
      if ($container.find(".wc-stars").length) {
        return;
      }

      // Create stars container
      var $stars = $('<div class="wc-stars"></div>');

      // Generate stars in reverse order (5 to 1)
      for (var i = 5; i >= 1; i--) {
        $stars.append(`
        <a href="#" class="star" data-value="${i}" title="Rate ${i} out of 5">
            <span class="star-icon">★</span>
        </a>
    `);
      }

      // Add stars and text display
      $select.after($stars);
      $stars.after('<div class="wc-rating-text"></div>');

      var $starLinks = $container.find(".star");
      var $ratingText = $container.find(".wc-rating-text");
      $ratingText.text("(0/5)");

      var texts = {
        1: "Very Poor",
        2: "Not that bad",
        3: "Average",
        4: "Good",
        5: "Perfect",
      };

      // Click handler
      $starLinks.on("click", function (e) {
        e.preventDefault();

        var $clickedStar = $(this);
        var value = parseInt($clickedStar.data("value"));

        // Update select
        $select.val(value).trigger("change");

        // Update stars visual - SIMPLE DIRECT METHOD
        $starLinks.each(function () {
          var $star = $(this);
          var starValue = parseInt($star.data("value"));

          // Direct style manipulation
          if (starValue <= value) {
            $star.find(".star-icon").css("color", "#FFBD13");
          } else {
            $star.find(".star-icon").css("color", "#ccc");
          }
        });

        // Update text
        // $ratingText.text(texts[value] + " (" + value + "/5)");
        $ratingText.text("(" + value + "/5)");

        // console.log("Selected:", value, "Select value:", $select.val());
      });

      // Initialize
      var currentValue = parseInt($select.val());
      if (currentValue) {
        $starLinks
          .filter('[data-value="' + currentValue + '"]')
          .trigger("click");
      }
    });
  }

  // Initialize
  createWooCommerceRating();

  // Re-initialize
  $(document).on("wpcf7reset wpcf7submit", function () {
    $(".wc-stars, .wc-rating-text").remove();
    setTimeout(createWooCommerceRating, 100);
  });

  /**
   * -------------------
   * ADV book form
   * -------------------
   */

  // Function to get URL parameters
  function getUrlParameter(name) {
    name = name.replace(/[\[]/, "\\[").replace(/[\]]/, "\\]");
    var regex = new RegExp("[\\?&]" + name + "=([^&#]*)");
    var results = regex.exec(location.search);
    return results === null
      ? ""
      : decodeURIComponent(results[1].replace(/\+/g, " "));
  }

  // Get the 'type' parameter from URL
  var urlType = getUrlParameter("type");

  // Clean up the value (remove quotes if present)
  urlType = urlType.replace(/["']/g, "");

  // Get the select element
  var $typeSelect = $('select[name="adv-type"]');

  if ($typeSelect.length && urlType) {
    // Check if the URL value matches one of the options
    var $option = $typeSelect.find('option[value="' + urlType + '"]');

    if ($option.length) {
      // Set the select value
      $typeSelect.val(urlType).trigger("change");

      // If it's banner type, ensure the file input is visible
      if (urlType === "banner") {
        $("#banner-upload").show();
        $('input[name="adv-banner-image"]').attr("aria-required", "true");
      }
    }
  }

  // Show/hide banner upload based on advertisement type selection
  $('select[name="adv-type"]').on("change", function () {
    if ($(this).val() === "banner" || $(this).val() === "بنر") {
      $("#banner-upload").slideDown();
      // Set aria-required to true
      $('input[name="adv-banner-image"]').attr("aria-required", "true");
    } else {
      $("#banner-upload").slideUp();
      // Set aria-required to false
      $('input[name="adv-banner-image"]').attr("aria-required", "false");
    }
  });

});
